import React from "react";

const SalesExplorationMeeting: React.FC = () => {
  return <div className="p-6">Sales exploration meeting</div>;
};

export default SalesExplorationMeeting;
